import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faPlus,
    faPrint,
    faEye,
    faXmark,
    faUser,
    faFileInvoice,
    faMapMarkerAlt,
    faTruck,
    faCalendar
} from "@fortawesome/free-solid-svg-icons";
import logoEmpresa from "../../../assets/images/logocot.png";
import logoEmpresaFoot from "../../../assets/images/logocotfoot.png";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getClientes } from "../../../services/clienteservice";
import {
    getCotizaciones,
    getDetalleCotizacion
} from "../../../services/cotizacionservice";

import "./cotizacion.css";

export default function Cotizacion() {

    const navigate = useNavigate();

    const [cotizaciones, setCotizaciones] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [busqueda, setBusqueda] = useState("");

    const [modalOpen, setModalOpen] = useState(false);
    const [form, setForm] = useState(null);

    useEffect(() => {
        cargarCotizaciones();
    }, []);

    const armarDetallesConTransporte = (cot, detalle) => {

        const items = Array.isArray(detalle) ? [...detalle] : [];

        const transporte = Number(cot.transporte || 0);

        if (transporte > 0) {
            items.push({
                nombre_item: "Transporte",
                cantidad: 1,
                precio: transporte,
                subtotal: transporte,
                esTransporte: true
            });
        }

        // 🔥 AQUÍ VA EL PASO 5
        items.sort((a, b) => {
            if (a.esTransporte) return 1;
            if (b.esTransporte) return -1;
            return 0;
        });

        return items;
    };


    const formatearCorrelativo = (id) => id ? String(id).padStart(6, '0') : '-';

    const cargarCotizaciones = async () => {
        try {
            const cotizacionesData = await getCotizaciones();
            const clientesData = await getClientes();

            setCotizaciones(cotizacionesData || []);
            setClientes(clientesData || []);

        } catch (error) {
            toast.error("Error cargando cotizaciones");
        }
    };

    const generarPDF = async (data) => {

        const html = document.createElement("div");

        html.innerHTML = `
        <div style="padding:30px;font-family:Arial;width:800px">

            <h2 style="text-align:center">COTIZACIÓN #${data.idcotizacion}</h2>

            <p><b>Cliente:</b> ${data.nombre} ${data.apellido}</p>
            <p><b>Razón Social:</b> ${data.razonsocial || "-"}</p>
            <p><b>Dirección:</b> ${data.direccion || "-"}</p>
            <p><b>Servicio:</b> ${data.servicio}</p>

            <hr/>

            <table border="1" width="100%" cellspacing="0" cellpadding="5">
                <thead>
                    <tr>
                        <th>Producto</th>
                        <th>Cant.</th>
                        <th>Precio</th>
                        <th>Subtotal</th>
                    </tr>
                </thead>
                <tbody>
                    ${data.detalles.map(d => `
                        <tr>
                            <td>${d.nombre_item || d.descripcion}</td>
                            <td>${d.cantidad}</td>
                            <td>${Number(d.precio).toFixed(2)}</td>
                            <td>${Number(d.subtotal).toFixed(2)}</td>
                        </tr>
                    `).join("")}
                </tbody>
            </table>

            <hr/>

            <p><b>Subtotal:</b> ${data.subtotal}</p>
            <p><b>IGV:</b> ${data.igv}</p>
            <p><b>Total:</b> ${data.total}</p>

        </div>
    `;

        document.body.appendChild(html);

        const canvas = await html2canvas(html);
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = 210;
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

        pdf.save(`cotizacion-${data.idcotizacion}.pdf`);

        document.body.removeChild(html);
    };

    const imprimirCotizacion = async (id) => {
        try {
            const detalleRaw = await getDetalleCotizacion(id);
            const cot = cotizaciones.find(c => c.idcotizacion === id);

            let fechaFormateada = "-";

            if (cot.fechareg) {
                const [year, month, day] = cot.fechareg.split("-");

                const fecha = new Date(
                    Number(year),
                    Number(month) - 1,
                    Number(day)
                );

                const fechaSucia = fecha.toLocaleDateString("es-ES", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                });

                fechaFormateada =
                    fechaSucia.charAt(0).toUpperCase() +
                    fechaSucia.slice(1);
            }

            if (!cot) {
                toast.error("No se encontró la cotización");
                return;
            }

            const cliente = clientes.find(cli =>
                cli.nombre === cot.nombre &&
                cli.apellido === cot.apellido
            );

            const detalles = armarDetallesConTransporte(cot, detalleRaw);

            // Creamos el contenedor temporal
            const html = document.createElement("div");

            // IMPORTANTE: Posicionar fuera de la pantalla para que no cause saltos visuales al usuario
            html.style.position = "absolute";
            html.style.left = "-9999px";
            html.style.top = "0";

            // Configuración del contenedor para simular el lienzo de impresión
            html.style.width = "820px";
            html.style.padding = "35px";
            html.style.boxSizing = "border-box";
            html.style.background = "#fff";
            html.style.fontFamily = "Arial, sans-serif";
            html.style.fontSize = "11px";
            html.style.color = "#000";

            // Separamos el ítem de transporte del resto
            const itemsNormales = detalles.filter(d =>
                !d.nombre_item?.toUpperCase().includes("TRANSPORTE") &&
                !d.descripcion?.toUpperCase().includes("TRANSPORTE")
            );

            const itemTransporte = detalles.find(d =>
                d.nombre_item?.toUpperCase().includes("TRANSPORTE") ||
                d.descripcion?.toUpperCase().includes("TRANSPORTE")
            );

            const montoTransporte = itemTransporte ? Number(itemTransporte.subtotal || 0).toFixed(2) : "0.00";

            html.innerHTML = `
        <table width="100%" cellspacing="0" cellpadding="0" style="border: 2px solid #000; border-collapse: collapse; background: #fff;">
            <tr>
                <td>
                    <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
                        <tr>
                            <td width="32%" valign="middle" align="center" style="padding: 10px 8px;">
                                <img src="${logoEmpresa}" alt="Logo JM" style="width: 100%; max-width: 190px; height: auto; object-fit: contain; display: block;" />
                            </td>
                            
                            <td width="68%" valign="top" style="border-left: 2px solid #000;">
                                <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
                                    <tr>
                                        <td align="center" style="padding: 6px; border-bottom: 1px solid #000; font-size: 13px;">
                                            <b>COTIZACIÓN N°</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b> ${formatearCorrelativo(cot.idcotizacion)}</b>
                                            <div style="font-size: 10px; margin-top: 2px; color: #444;">${fechaFormateada}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 5px 10px;">
                                            <table width="100%" cellspacing="0" cellpadding="2.5" style="font-size: 10px;">
                                                <tr>
                                                    <td width="15%"><b>Cliente:</b></td>
                                                    <td style="border: 1px solid #000; padding-left: 5px; height: 16px;">${cot.razonsocial || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Dirección:</b></td>
                                                    <td style="border: 1px solid #000; padding-left: 5px; height: 16px;">${cot.direccion || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>RUC:</b></td>
                                                    <td style="border: 1px solid #000; padding-left: 5px; height: 16px;">${cliente?.documento || "-"}</td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <table width="100%" cellspacing="0" cellpadding="5" style="border-top: 2px solid #000; border-bottom: 2px solid #000; border-collapse: collapse; font-size: 10.5px;">
                        <tr>
                            <td width="15%" rowspan="2" style="border-right: 1px solid #000; padding-left: 10px; vertical-align: middle;"><b>Servicio de:</b></td>
                            <td width="45%" rowspan="2" align="center" style="border-right: 1px solid #000; font-weight: bold; font-size: 11px; vertical-align: middle; letter-spacing: 0.5px; text-transform: uppercase;">
                                ${(cot.servicio || "ALQUILER DE MOBILIARIO").toUpperCase()}
                            </td>
                            <td width="12%" style="border-right: 1px solid #000; border-bottom: 1px solid #000; padding-left: 10px;"><b>Montaje:</b></td>
                            <td width="28%" style="border-bottom: 1px solid #000;">${cot.montaje || "-"}</td>
                        </tr>
                        <tr>
                            <td style="border-right: 1px solid #000; padding-left: 10px;"><b>Desmontaje:</b></td>
                            <td>${cot.desmontaje || "-"}</td>
                        </tr>
                    </table>

                    <div style="padding: 7px; font-size: 10.5px; text-align: left; padding-left: 15px; border-bottom: 1px solid #000; font-style: italic;">
                        Por intermedio de la presente reciba un cordial saludo y a la vez les hacemos llegar nuestra propuesta:
                    </div>

                    <table width="100%" cellspacing="0" cellpadding="5" style="border-collapse: collapse; font-size: 10.5px;">
                        <thead>
                            <tr align="center" style="font-weight: bold; font-size: 10px;">
                                <td width="5%" style="border-right: 1px solid #000; border-bottom: 1px solid #000;">ITEM</td>
                                <td width="5%" style="border-right: 1px solid #000; border-bottom: 1px solid #000;">CANT.</td>
                                <td width="56%" style="border-right: 1px solid #000; border-bottom: 1px solid #000;">DESCRIPCIÓN</td>
                                <td width="17%" style="border-right: 1px solid #000; border-bottom: 1px solid #000;">VALOR UNITARIO</td>
                                <td width="17%" style="border-bottom: 1px solid #000;">VALOR TOTAL</td>
                            </tr>
                        </thead>
                        <tbody>
                            ${itemsNormales.map((d, index) => `
                                <tr style="height: 38px;">
                                    <td align="center" style="border-right: 1px solid #000; vertical-align: middle;">${String(index + 1).padStart(2, '0')}</td>
                                    <td align="center" style="border-right: 1px solid #000; vertical-align: middle;">${d.cantidad}</td>
                                    <td style="border-right: 1px solid #000; padding-left: 15px; vertical-align: middle; text-transform: uppercase;">
                                        ${d.nombre_item || d.descripcion || "-"}
                                    </td>
                                    <td align="right" style="border-right: 1px solid #000; padding-right: 15px; vertical-align: middle;">
                                        S/ ${Number(d.precio || 0).toFixed(2)}
                                    </td>
                                    <td align="right" style="padding-right: 15px; vertical-align: middle;">
                                        S/ ${Number(d.subtotal || 0).toFixed(2)}
                                    </td>
                                </tr>
                            `).join("")}

                            ${itemsNormales.length < 3 ? `
                                <tr style="height: 140px;">
                                    <td style="border-right: 1px solid #000;"></td>
                                    <td style="border-right: 1px solid #000;"></td>
                                    <td style="border-right: 1px solid #000;"></td>
                                    <td style="border-right: 1px solid #000;"></td>
                                    <td></td>
                                </tr>
                            ` : ''}

                            <tr style="border-top: 1px solid #000; border-bottom: 2px solid #000; font-weight: bold; height: 32px;">
                                <td align="center" style="border-right: 1px solid #000;">**</td>
                                <td align="center" style="border-right: 1px solid #000;">**</td>
                                <td align="center" style="border-right: 1px solid #000; letter-spacing: 2px; font-size: 10px;">** TRANSPORTE **</td>
                                <td align="center" style="border-right: 1px solid #000;">**</td>
                                <td align="right" style="padding-right: 15px;">S/ ${montoTransporte}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse; font-size: 10.5px;">
                        <tr>
                            <td width="66%">&nbsp;</td>
                            <td width="34%" valign="top">
                                <table width="100%" cellspacing="0" cellpadding="6" style="border-left: 1px solid #000; border-collapse: collapse; text-align: right; font-weight: bold;">
                                    <tr>
                                        <td width="50%" style="border-bottom: 1px solid #000; border-right: 1px solid #000; padding-right: 10px;">SUBTOTAL</td>
                                        <td width="50%" style="border-bottom: 1px solid #000; padding-right: 15px;">S/ ${Number(cot.subtotal || 0).toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td style="border-bottom: 1px solid #000; border-right: 1px solid #000; padding-right: 10px;">IGV</td>
                                        <td width="50%" style="border-bottom: 1px solid #000; padding-right: 15px;">S/ ${Number(cot.igv || 0).toFixed(2)}</td>
                                    </tr>
                                    <tr style="font-size: 12px; background: #f2f2f2;">
                                        <td style="border-right: 1px solid #000; padding-right: 10px; padding-top: 8px; padding-bottom: 8px;">TOTAL</td>
                                        <td style="padding-right: 15px; padding-top: 8px; padding-bottom: 8px;">S/ ${Number(cot.total || 0).toFixed(2)}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <table width="100%" cellspacing="0" cellpadding="8" style="border-top: 2px solid #000; border-collapse: collapse; font-size: 9.5px; text-align: center;">
                        <tr>
                            <td width="78%" valign="middle" style="padding-top: 12px;">
                                <div style="font-weight: bold; font-size: 10.5px; margin-bottom: 3px;">JM SOLUCIONES GENERALES S.R.L.</div>
                                <div style="margin-bottom: 12px; letter-spacing: 0.5px;">20538597806</div>
                                <table width="100%" cellspacing="0" cellpadding="0">
                                    <tr>
                                        <td width="50%">
                                            <span style="text-decoration: underline; color: blue;">Marilú Vargas</span><br>
                                            <b style="font-size: 10px;">998 271 322</b>
                                        </td>
                                        <td width="50%">
                                            <span style="text-decoration: underline; color: blue;">Javier Zuloeta</span><br>
                                            <b style="font-size: 10px;">994208097</b>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td width="22%" align="center" valign="middle" style="border-left: 1px solid #000; padding: 5px;">
                                <img src="${logoEmpresaFoot}" alt="Logo JM Footer" style="width: 100px; height: auto; opacity: 0.85; margin: 0 auto;" />
                            </td>
                        </tr>
                    </table>

                </td>
            </tr>
        </table>
        `;

            document.body.appendChild(html);

            // Esperar un breve instante para asegurar que las imágenes se rendericen completamente en el DOM
            await new Promise((resolve) => setTimeout(resolve, 300));

            const canvas = await html2canvas(html, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: "#ffffff" // Evita fondos negros o transparentes inesperados
            });

            const imgData = canvas.toDataURL("image/jpeg", 0.95); // JPEG suele pesar menos que PNG en PDFs de este tipo
            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

            pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(`cotizacion-${cot.idcotizacion}.pdf`);

            document.body.removeChild(html);

        } catch (error) {
            console.error("Error imprimiendo:", error);
            toast.error("Error al generar PDF");

            // Limpieza de seguridad por si falla a mitad del proceso
            const tempDiv = document.querySelector('[style*="left: -9999px"]');
            if (tempDiv) tempDiv.remove();
        }
    };
    const verDetalle = async (c) => {
        try {
            const detalleRaw = await getDetalleCotizacion(c.idcotizacion);

            const detalle = Array.isArray(detalleRaw) ? detalleRaw : [];

            const cliente = clientes.find(cli =>
                cli.nombre === c.nombre &&
                cli.apellido === c.apellido
            );

            const formData = {
                ...c,
                documento: cliente?.documento || "",
                direccion: cliente?.direccion || c.direccion || "",
                detalles: armarDetallesConTransporte(c, detalle)
            };

            setForm(formData);
            setModalOpen(true);

        } catch (error) {
            console.error("❌ ERROR EN verDetalle:", error);
            toast.error("Error cargando detalle");
        }
    };

    const formatCorrelativo = (id) =>
        `COT-${String(id).padStart(6, "0")}`;

    const filtradas = cotizaciones.filter(c =>
        (c.razonsocial || "").toLowerCase().includes(busqueda.toLowerCase()) ||
        c.idcotizacion?.toString().includes(busqueda)
    );

    return (
        <div className="cotizacion-page">

            <ToastContainer />

            {/* HEADER */}
            <div className="cotizacion-header">

                <div className="cotizacion-search">
                    <FontAwesomeIcon icon={faSearch} className="cotizacion-search-icon" />
                    <input
                        placeholder="Buscar cotización..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>

                <button
                    className="cotizacion-btn-nuevo"
                    onClick={() => navigate("/inicio/cotizacion/agregar")}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    Nueva
                </button>

            </div>

            {/* TABLE */}
            <div className="cotizacion-table-container">

                <table>

                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Cliente</th>
                            <th>Subtotal</th>
                            <th>Total</th>
                            <th>Fecha</th>
                            <th style={{ textAlign: "center" }}>Acción</th>
                        </tr>
                    </thead>

                    <tbody>

                        {filtradas.length > 0 ? filtradas.map(c => (
                            <tr key={c.idcotizacion} className="row-hover">

                                <td>{formatCorrelativo(c.idcotizacion)}</td>
                                <td>{c.nombre + " " + c.apellido}</td>
                                <td>S/ {c.subtotal}</td>
                                <td className="total-cell">S/ {c.total}</td>
                                <td>{c.fechareg}</td>

                                <td className="action-cell">

                                    <button
                                        className="cotizacion-eye-btn"
                                        onClick={() => verDetalle(c)}
                                    >
                                        <FontAwesomeIcon icon={faEye} />
                                    </button>

                                    <button
                                        className="cotizacion-print-btn"
                                        onClick={() => imprimirCotizacion(c.idcotizacion)}
                                    >
                                        <FontAwesomeIcon icon={faPrint} />
                                    </button>

                                </td>

                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                                    No hay cotizaciones
                                </td>
                            </tr>
                        )}

                    </tbody>

                </table>

            </div>

            {/* MODAL */}
            {modalOpen && form && (

                <div className="cotizacion-modal-overlay" onClick={() => setModalOpen(false)}>

                    <div className="cotizacion-modal" onClick={(e) => e.stopPropagation()}>

                        {/* HEADER */}
                        <div className="cotizacion-modal-header">

                            <h2>Cotización #{form.idcotizacion}</h2>

                            <button onClick={() => setModalOpen(false)}>
                                <FontAwesomeIcon icon={faXmark} />
                            </button>

                        </div>

                        {/* INFO CLIENTE */}
                        <div className="topcontainer">

                            {/* CORRELATIVO RESTAURADO */}
                            <div className="field">
                                <label>Correlativo</label>
                                <div className="input-box">
                                    <FontAwesomeIcon icon={faFileInvoice} className="input-icon" />
                                    <input
                                        value={formatCorrelativo(form.idcotizacion)}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="field">
                                <label>Cliente</label>
                                <div className="input-box">
                                    <FontAwesomeIcon icon={faUser} className="input-icon" />
                                    <input value={`${form.nombre || ""} ${form.apellido || ""}`} readOnly />
                                </div>
                            </div>

                            <div className="field">
                                <label>Razón Social</label>
                                <div className="input-box">
                                    <FontAwesomeIcon icon={faUser} className="input-icon" />
                                    <input value={form.razonsocial || "N/A"} readOnly />
                                </div>
                            </div>

                            <div className="field">
                                <label>Documento</label>
                                <div className="input-box">
                                    <FontAwesomeIcon icon={faFileInvoice} className="input-icon" />
                                    <input value={form.documento || ""} readOnly />
                                </div>
                            </div>

                            <div className="field">
                                <label>Dirección</label>
                                <div className="input-box">
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className="input-icon" />
                                    <input value={form.direccion || ""} readOnly />
                                </div>
                            </div>

                            <div className="field">
                                <label>Servicio</label>
                                <div className="input-box">
                                    <FontAwesomeIcon icon={faTruck} className="input-icon" />
                                    <input value={form.servicio || ""} readOnly />
                                </div>
                            </div>

                            <div className="field">
                                <label>Montaje</label>
                                <div className="input-box">
                                    <FontAwesomeIcon icon={faCalendar} className="input-icon" />
                                    <input value={form.montaje || ""} readOnly />
                                </div>
                            </div>

                            <div className="field">
                                <label>Desmontaje</label>
                                <div className="input-box">
                                    <FontAwesomeIcon icon={faCalendar} className="input-icon" />
                                    <input value={form.desmontaje || ""} readOnly />
                                </div>
                            </div>

                        </div>

                        {/* DETALLES */}
                        <div className="detalle-box">

                            <h3>Productos</h3>

                            <table className="detalle-table">
                                <thead>
                                    <tr>
                                        <th>Producto</th>
                                        <th>Cant.</th>
                                        <th>Precio</th>
                                        <th>Subtotal</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Array.isArray(form?.detalles) && form.detalles.length > 0 ? (
                                        (form.detalles || []).map((d, i) => {

                                            return (
                                                <tr key={i}>

                                                    <td>
                                                        {d.nombre_item || d.descripcion || "SIN NOMBRE"}
                                                    </td>

                                                    <td>{d.cantidad ?? 0}</td>

                                                    <td>
                                                        S/ {Number(d.precio || 0).toFixed(2)}
                                                    </td>

                                                    <td>
                                                        S/ {Number(d.subtotal || 0).toFixed(2)}
                                                    </td>

                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center" }}>
                                                ⚠️ No hay detalles o llegaron vacíos
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                        </div>

                        {/* TOTALES */}
                        <div className="summary-box">

                            <div>Subtotal: <b>S/ {form.subtotal}</b></div>
                            <div>IGV: <b>S/ {form.igv}</b></div>
                            <div className="total-highlight">
                                Total: S/ {form.total}
                            </div>

                        </div>

                        <button className="btn-cerrar" onClick={() => setModalOpen(false)}>
                            Cerrar
                        </button>

                    </div>

                </div>

            )}

        </div>
    );
}